import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../data/mockData';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="relative bg-[#121212] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-[7.6923%] py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div>
            <img 
              src="/logo.png" 
              alt="NotchUp Virtual Tours" 
              className="h-12 object-contain mb-6"
            />
            <p className="body-small text-white/70 mb-6">
              Professional 360° Virtual Tours for businesses across Manipal, Udupi & Karnataka. 
              Showcase your space like never before.
            </p>
            <div className="flex gap-4">
              <a 
                href={mockData.socialLinks.facebook} 
                className="w-10 h-10 bg-white/5 hover:bg-[#00FFD1]/20 border border-white/10 hover:border-[#00FFD1]/50 flex items-center justify-center transition-all duration-400"
              >
                <Facebook className="w-5 h-5 text-white/70 hover:text-[#00FFD1]" />
              </a>
              <a 
                href={mockData.socialLinks.instagram} 
                className="w-10 h-10 bg-white/5 hover:bg-[#00FFD1]/20 border border-white/10 hover:border-[#00FFD1]/50 flex items-center justify-center transition-all duration-400"
              >
                <Instagram className="w-5 h-5 text-white/70 hover:text-[#00FFD1]" />
              </a>
              <a 
                href={mockData.socialLinks.linkedin} 
                className="w-10 h-10 bg-white/5 hover:bg-[#00FFD1]/20 border border-white/10 hover:border-[#00FFD1]/50 flex items-center justify-center transition-all duration-400"
              >
                <Linkedin className="w-5 h-5 text-white/70 hover:text-[#00FFD1]" />
              </a>
              <a 
                href={mockData.socialLinks.youtube} 
                className="w-10 h-10 bg-white/5 hover:bg-[#00FFD1]/20 border border-white/10 hover:border-[#00FFD1]/50 flex items-center justify-center transition-all duration-400"
              >
                <Youtube className="w-5 h-5 text-white/70 hover:text-[#00FFD1]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 text-white mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="body-small text-white/70 hover:text-[#00FFD1] transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="body-small text-white/70 hover:text-[#00FFD1] transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="body-small text-white/70 hover:text-[#00FFD1] transition-colors">
                  Gallery
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="body-small text-white/70 hover:text-[#00FFD1] transition-colors">
                  Our Process
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="body-small text-white/70 hover:text-[#00FFD1] transition-colors">
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3 text-white mb-6">Industries</h4>
            <ul className="space-y-3">
              <li className="body-small text-white/70">Hotels & Resorts</li>
              <li className="body-small text-white/70">Restaurants & Cafés</li>
              <li className="body-small text-white/70">Real Estate</li>
              <li className="body-small text-white/70">Educational Institutions</li>
              <li className="body-small text-white/70">Commercial Spaces</li>
              <li className="body-small text-white/70">Healthcare Facilities</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="heading-3 text-white mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#00FFD1] flex-shrink-0 mt-0.5" />
                <a 
                  href={`mailto:${mockData.company.email}`}
                  className="body-small text-white/70 hover:text-[#00FFD1] transition-colors"
                >
                  {mockData.company.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#00FFD1] flex-shrink-0 mt-0.5" />
                <span className="body-small text-white/70">
                  {mockData.company.phone}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#00FFD1] flex-shrink-0 mt-0.5" />
                <span className="body-small text-white/70">
                  {mockData.company.location}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="body-small text-white/60">
              © {new Date().getFullYear()} {mockData.company.name}. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="body-small text-white/60 hover:text-[#00FFD1] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="body-small text-white/60 hover:text-[#00FFD1] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
